import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
var logoProps = {
  width: 60,
  height: 60,
  borderRadius: '50%'
};
/**
 * @param {{ installation: import('./types').MicroserviceInstallationServerStatusState, progress?: number, appName?: string, appIcon?: string }} props
 */

var AppStatus = function AppStatus(_ref) {
  var installation = _ref.installation,
      progress = _ref.progress,
      appName = _ref.appName,
      appIcon = _ref.appIcon;
  if (!installation) return null;
  var status = null;
  if (installation.status === 'UNINSTALLED') status = 'Not installed';else if (installation.status === 'INSTALLED') status = 'Installed';else if (installation.status === 'INSTALL_ERROR') status = 'Install error';else if (installation.status === 'UNINSTALL_ERROR') status = 'Uninstall error';
  var processing = false;
  var details = null;

  if (installation.status === 'INSTALLING') {
    processing = true;
    details = 'Installing...';
  } else if (installation.status === 'UNINSTALLING') {
    processing = true;
    details = 'Uninstalling...';
  }

  if (processing && installation.step) details = installation.step;
  return React.createElement(Grid, {
    container: true,
    direction: "row",
    spacing: 3,
    alignItems: "center",
    style: {
      maxWidth: processing ? undefined : 240,
      margin: 'auto',
      textAlign: 'left'
    }
  }, React.createElement(Grid, {
    item: true
  }, appIcon ? React.createElement("img", {
    alt: appName,
    src: appIcon,
    style: logoProps
  }) : React.createElement("div", {
    style: _objectSpread({}, logoProps, {
      opacity: 0.5,
      backgroundColor: 'grey'
    })
  })), React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    color: "inherit",
    variant: "subtitle1"
  }, appName, React.createElement(Typography, {
    color: "inherit",
    style: {
      opacity: 0.6
    }
  }, details)), React.createElement(Typography, {
    color: "inherit",
    style: {
      opacity: 0.6
    },
    gutterBottom: true
  }, status), processing && React.createElement(LinearProgress, {
    style: {
      marginTop: 8,
      marginBottom: 16
    },
    variant: typeof progress === 'number' ? 'determinate' : 'indeterminate',
    value: progress
  })));
};

export default AppStatus;